import { useState, useEffect, useRef } from 'react';
import Bredcrum from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import { Tablescom } from '../../components/tablescomp';
import { userservices } from '../../services/userServices';
import { productservices } from '../../services/productServices';
import { Titlebar, Searchbox, Stockstatus, Stockstatusavailability, Importexceldata,Confirmdialog2,Orderstatus,ProfitLoss } from '../../components/fieldsComp';

import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router";
import { supplierservices } from '../../services/supplierServices'
import { StockServices } from '../../services/stockServices';
import { Dialog } from 'primereact/dialog';
import { TabMenu } from 'primereact/tabmenu';
import { exportToExcel } from '../../helpers/exporttoexcel';
import { Toast } from "primereact/toast";
import { convertFileToBase64 } from '../../helpers/base64conversion';
import { FcRefresh } from "react-icons/fc";
import { AiOutlineRetweet } from "react-icons/ai";
import { saleServices } from '../../services/saleServices';
import { useFormikContext,useFormik,Field,Formik,Form,FieldArray } from 'formik';

const Profitlossreports = ({ dashboard = false }) => {
  const toast = useRef(null);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [results, setResults] = useState([]);
  const [userloaded, setUserloaded] = useState(true);
  const [stockdialog, setStockDialog] = useState(false);
  const [detailinfo, setDetailinfo] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // 🔄 dynamic page size
  const [quickFilterText, setQuickFilterText] = useState('');
  const [filter, setfilter] = useState({ 'year': '', 'month': '','status':'all' });
  const [statusset, setStatusset] = useState('merged');
  const [visible, setVisible] = useState(false);
  const [popvisible, setPopvisible] = useState(false);
  const [viewvisible, setViewvisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [calculations, setCalculation] = useState({ 'profit':'', 'total_purchase' : ''});
  const [newParams , setNewParams] = useState({});
  const gridref = useRef();
  

  const items = [
    {
      label: 'Yearly',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('yearly'),
      // template: (item) => itemRenderer(item, 0)
    },
     {
      label: 'Monthly',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('monthly'),
      // template: (item) => itemRenderer(item, 0)
    },
    // {
    //   label: 'All',
    //   icon: 'fa fa-angle-right',
    //   command: () => handleStockFilter('all'),
    //   // template: (item) => itemRenderer(item, 0)
    // },
    // {
    //   label: 'Merged',
    //   icon: 'fa fa-angle-right',
    //   command: () => handleStockFilter('merged'),
    //   // template: (item) => itemRenderer(item, 0)
    // },
    // {
    //   label: 'Profit',
    //   icon: 'fa fa-angle-right',
    //   command: () => handleStockFilter('profit'),
    //   // template: (item) => itemRenderer(item, 0)
    // },
    // {
    //   label: 'Loss',
    //   icon: 'fa fa-angle-right',
    //   command: () => handleStockFilter('loss'),
    //   //  template: (item) => itemRenderer(item, 1)
    // },
  ];


  function handleStockFilter(status) {
    setfilter((prevData)=>{
      return{
          ...prevData,
          status:status
      }
    });
  }


  useEffect(() => {
    profitlossreport();
    // setNewParams(params);  
  }, [statusset, currentPage, pageSize]);

  useEffect(() => {
    setColDefs(getColDefs(currentPage, pageSize));
  }, [statusset, currentPage, pageSize]);


  useEffect(() => {
    setColDefs(getColDefs(currentPage, pageSize));
  }, [filter.status]);

  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const getColDefs = (currentPage, pageSize) => [
    {
      headerName: "SR NO", field: "id", width: 50,
      valueGetter: (params) => {
        return ((currentPage - 1) * pageSize) + params.node.rowIndex + 1;
      },
    },
    
    // {
    //   headerName: "Order No", field: "order_id"
    // },
    { headerName: "Product", field: "product_name",cellStyle: {
      
      }, },
    {
      headerName: "Sku Code", field: "product"
    }, 
    {
     headerName:"Month",field:"formatted_date",
     hide: filter.status == 'yearly', 
    },
    {
     headerName:"Year",field:"formatted_date",
     hide: filter.status == 'monthly', 
    },
      { headerName: "Units Sold", field: "total_units", width:100,
      valueGetter: (params) => {
          return params.data.total_units ?? params.data.total_units ?? 0;
        }
      },
     
    {
      headerName: "TP", field: "total_purchase"
    }, 
     {
      headerName:"Freight Charge", field : "freight_charges" 
    },
     {
      headerName: "Revenue", field: "revenue"
    }, 
    
    {
      headerName: "Profit Cost", field: "total_profit"
    }, 
    {
      headerName: "Is Profit", field: "revenue_profit",cellRenderer: (params) => {
        return <ProfitLoss  status={params.getValue()}/>; // +1 to start from 1 instead of 0
      }
    }, 
];
  const [colDefs, setColDefs] = useState(getColDefs(1, 5));

  const getRowClass = params => {
    if (params.data.Instock === 'lowstock') {
      return 'low-stock';
    } else if (params.data.Instock === 'instock') {
      return 'in-stock';
    } else if (params.data.Instock === 'outofstock') {
      return 'out-of-stock';
    }
    else if (params.data.Instock === 'overstock') {
      return 'over-stock';
    }
    return '';
  };

  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    profitlossreport();      // reload with new size
  };

  
  const onHide = () => {
    setVisible(false);
  };
  

  useEffect(()=>{
     profitlossreport();
  },[filter])

  const profitlossreport = () =>{
      setUserloaded(true);
      StockServices.profitlossreport({status:filter.status,page:currentPage,limit:pageSize,year:filter.year,month:filter.month}).then((response)=>{
         if(response.status == 200){
            // console.log(response.data.data);
            setResults(response.data.data);
            setUserloaded(false);
            setTotalRows(response.data.total);
            setCalculation(response.data.totals);
        }else{
            setResults([]);
            setUserloaded(false);
            setTotalRows(0);
            setCalculation({});
         }
      }).catch((error)=>{
          setResults([]);
          setUserloaded(false);
          setTotalRows(0);
          setCalculation({});
      })
  }

  useEffect(()=>{
      setInterval(()=>{
        //  salesReport();   
      },5000)  
  },[])

  const onSelectYear = (value) => {
    setfilter((prevData)=>{
      return {
        ...prevData,
        year:value,
        status: 'yearly',
      }
    })
  }

  const onSelectMonth = (value) => {
    setfilter((prevData)=>{
      return {
        ...prevData,
        month:value,
        status: 'monthly'
      }
    })
  }

  const uploaddata = async (e) => {
    e.preventDefault();
    setLoading(true); // show loader
    let file = e.target.file.files[0];
    const base64 = await convertFileToBase64(file);
    StockServices.createmultistockupdate(base64).then((response) => {
      if (response.status == 200) {
        setVisible(false);
        setLoading(false); // show loader
        // toast.current.show({ severity: 'success', summary: 'Stock Update', detail: response.data.data });
        // getstocks(statusset, currentPage, pageSize);
      } else {
        // toast.current.show({ severity: 'error', summary: 'Stock Update', detail: `${response.data.data}` });
        setVisible(false);
        setLoading(true); // show loader
      }
    }).catch((error) => {

    });
  }

  const handleExport = () => {
    exportToExcel({ data: results, filename: 'stock' });
  }

  const ProfitLossStatus = () => {
    if(calculations.profit > calculations.total_purchase){
      return <ProfitLoss style="p-10" status={"profit"}/>
    }else{
      return <ProfitLoss status={'loss'} />
    }
  } 

  const samplepath = "stockupdate.xlsx";
  return (
    <>
      <Toast ref={toast} />
      <Importexceldata
        visible={visible}
        onHide={onHide}
        onSubmit={uploaddata}
        samplepath={samplepath}
        loading={loading}
      />

      {dashboard ? (<>
        <div className="col-md-12 mt-3">
          {/* <div className='row'>
            <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
          </div> */}
          <div className='card'>
            <div className='card-body card-body-style'>
              {/* {DisplayComp(activeIndex)} */}

               {/* <Formik
                initialValues={{}}
                enableReinitialize={true}
                onSubmit={async (values) => {
                    setfilter((prevData)=>{
                        return { 
                          ...prevData,
                          fromdate: values.fromdate, 
                          todate: values.todate }  
                       }
                    );
                }}
                >
                <Form>
                    <div className='flex-box pb-3'>
                    <div className='flex-box flex-column date-box-style pb-2'>
                        <div className='pb-2 primary-text-color'><label>From date</label> </div>
                        <Field type="date" name="fromdate" placeholder='From date' className='primary-text-color date-input-style' />
                    </div>
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    <div className='flex-box flex-column date-box-style pb-2'>
                        <div className='pb-2 primary-text-color'><label>To date</label> </div>
                        <Field type="date" name="todate" placeholder='To date' className='primary-text-color date-input-style' />
                    </div>
                    &nbsp;
                    &nbsp;

                    <div className='date-box'>
                        <button type='submit' className='btn-success text-white'>Filter</button>
                    </div>
                    </div>
                </Form>
                </Formik> */}
              <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText} paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                handlePrevious={handlePrevious}
                handlePageSizeChange={handlePageSizeChange} gridref={gridref} getRowClass={getRowClass} />
            </div>
          </div>
        </div>
      </>) : (<>
      {/* <Bredcrum title={'P&L Report'} divider={false} /> */}
        <div class="row">
          {/* <Titlebar text={'Sales Report'} /> */}
          <div className="col-md-12 mt-3">
            <div className='row'>
              <div className='col-md-9'>
                <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
              </div>

              <div className='col-md-3'>
                <div>
                  <button class="export-btn form-control w-50 pull-right" onClick={() => handleExport()}>
                    <i className='fa fa-file-excel'></i> &nbsp;Export to Excel</button>
                </div>
              </div>
            </div>
            <div className='card'>
              <div className='card-body card-body-style'>
                {/* {DisplayComp(activeIndex)} */}
                <div className='flex-box pb-3' style={{justifyContent: 'space-between'}}>
                <Formik
                initialValues={{}}
                enableReinitialize={true}
               onSubmit={async (values) => {
                    setfilter((prevData)=>{
                        return { 
                          ...prevData,
                          fromdate: values.fromdate, 
                          todate: values.todate }  
                       }
                    );
                }}
                >
                <Form>
                    <div className='flex-box pb-3'>
                    {/* <div className='flex-box flex-column date-box-style pb-2'>
                        <div className='pb-2 primary-text-color'><label>From date</label> </div>
                        <Field type="date" name="fromdate" placeholder='From date' className='primary-text-color date-input-style' />
                    </div>
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    

                    <div className='flex-box flex-column date-box-style pb-2'>
                        <div className='pb-2 primary-text-color'><label>To date</label> </div>
                        <Field type="date" name="todate" placeholder='To date' className='primary-text-color date-input-style' />
                    </div> */}

                    { (filter.status == 'yearly' || filter.status == 'all') ? (<div className='flex-box flex-column date-box-style pb-2'>
                        <div className='pb-2 primary-text-color'><label>Select Year</label></div>
                        <Field as="select" name="year" className="form-control primary-text-color date-inputs-style" onChange={(e) => onSelectYear(e.target.value)} >
                            <option value="all">All</option>
                            <option value="2024">2024</option>
                            <option value="2023">2023</option>
                            <option value="2022">2022</option>
                            <option value="2021">2021</option>
                            <option value="2020">2020</option>
                        </Field>
                        &nbsp;
                        &nbsp;
                    </div>
                  ):(

                    <div className='flex-box flex-column date-box-style pb-2'>
                        <div className='pb-2 primary-text-color'><label>Select Month</label></div>
                        <Field as="select" name="month" className="form-control primary-text-color date-inputs-style" onChange={(e) => onSelectMonth(e.target.value)}>
                            <optin value="all">All</optin>
                            <option value="01">January</option>
                            <option value="02">Febuary</option>
                            <option value="03">March</option>
                            <option value="04">April</option>
                            <option value="05">May</option>
                            <option value="06">June</option>
                            <option value="07">July</option>
                            <option value="08">August</option>
                            <option value="09">September</option>
                            <option value="10">October</option>
                            <option value="11">November</option>
                            <option value="12">December</option>
                        </Field>
                    </div>)}

                    <div className='date-box'>
                      
                        <button type='submit' className='form-control btn-success text-white '>Filter</button>
                    </div>
                    </div>
                </Form>
                </Formik>

                    <div className='flex-box pb-4'>
                      <ProfitLossStatus />
                      <Tag style={{fontSize:'15px',background:'transparent',color:'#783c3c'}} value={"Total Purchase Price : " + (calculations.total_purchase != undefined ? calculations.total_purchase : 'N/A') + " | Profit : " + (calculations.profit != undefined ? calculations.profit : 'N/A')}></Tag>
                    </div>
                
                </div>

                <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText} paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                  totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                  handlePrevious={handlePrevious}
                  handlePageSizeChange={handlePageSizeChange} gridref={gridref} getRowClass={getRowClass} />
              </div>
            </div>
          </div>
        </div></>)}
    </>
 );
}
export default Profitlossreports;